<template>
    <div class="min-h-screen flex items-center justify-center bg-gray-50 dark:bg-gray-900">
      <div class="w-full max-w-md bg-white dark:bg-slate-800 rounded-xl shadow p-6">
        <h1 class="text-2xl font-semibold mb-6 text-gray-900 dark:text-gray-100">Alterar senha</h1>
  
        <form @submit.prevent="update_password" class="space-y-4">
           <!-- Nome -->
            <div>
                <label class="block text-sm mb-1 text-gray-700 dark:text-gray-200">Nome</label>
                <p class="w-full px-3 py-2 border rounded-md dark:bg-slate-800 dark:border-slate-700 dark:text-gray-100">
                    {{ name }}
                </p>
            </div>
  
            <div>
                <label class="block text-sm mb-1 text-gray-700 dark:text-gray-200">Email</label>
                <p class="w-full px-3 py-2 border rounded-md dark:bg-slate-800 dark:border-slate-700 dark:text-gray-100">
                    {{ email }}
                </p>
            </div>
  
          <!-- Gerência (novo) -->
          <div>
                <label class="block text-sm mb-1 text-gray-700 dark:text-gray-200">Gerência</label>
                <p class="w-full px-3 py-2 border rounded-md dark:bg-slate-800 dark:border-slate-700 dark:text-gray-100">
                    {{ unit }}
                </p>
            </div>
            <!-- Senha -->
          <div>
            <label class="block text-sm mb-1 text-gray-700 dark:text-gray-200">Senha</label>
            <input v-model="password" type="password" minlength="6" required
                   class="w-full px-3 py-2 border rounded-md dark:bg-slate-800 dark:border-slate-700 dark:text-gray-100"/>
          </div>
  
          <div>
            <label class="block text-sm mb-1 text-gray-700 dark:text-gray-200">Confirmar senha</label>
            <input v-model="password2" type="password" minlength="6" required
                   class="w-full px-3 py-2 border rounded-md dark:bg-slate-800 dark:border-slate-700 dark:text-gray-100"/>
          </div>
          <p class="mt-4 text-sm text-gray-700 dark:text-gray-100">
            <router-link to="/" class="text-emerald-500 hover:underline">Voltar para o formulário</router-link>
          </p>
  
          <fwb-button gradient="green-blue" outline class="w-full py-2" :disabled="loading">
            {{ loading ? 'Criando…' : 'Alterar a senha' }}
          </fwb-button>
        </form>
  
        <p v-if="error" class="mt-4 text-sm text-red-500">{{ error }}</p>
      </div>
    </div>
  </template>
  
  <script>
  import axios from 'axios'
  import { FwbButton } from 'flowbite-vue'
  
  export default {
    name: 'ProfileMain',
    components: { FwbButton },
    data() {
      return {
        name: '', email: '', unit: '',
        password: '', password2: '',
        loading: false, error: '', apiBase: '/api',
      }
    },
    async created() {

        const token = localStorage.getItem('token')
        if (token) axios.defaults.headers.common['Authorization'] = `Bearer ${token}`
        try {
            const {data: userData} = await axios.get(`${this.apiBase}/auth/me`)
            this.name = userData.name 
            this.email = userData.email
            this.unit = userData.unit
           
        } catch(e) {
            this.error = e?.response?.data?.error || 'Problema de autenticação'
            console.error(e)  
        }
      },
    methods: {
      
      async update_password() {
        this.error = ''
        if (this.password !== this.password2) {
          this.error = 'As duas senhas não são iguais.'
          return
        }

        this.loading = true
        
        try {
        
            await axios.post(`${this.apiBase}/auth/update-password`, {
            password: this.password,
          })

          const redirect = this.$route.query.redirect || '/'
          this.$router.replace(redirect)

        } catch (e) {
          this.error = e?.response?.data?.error || 'Não foi possível alterar a senha.'
          console.error(e)
        } finally {
          this.loading = false
        }
      }
    }
  }
  </script>
  